var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input-field',{attrs:{"label":_vm.label,"type":"text","value":_vm.value,"validation":_vm.validation,"dark":_vm.dark,"placeholder":"DD/MM/AAAA","disabled":_vm.disabled,"mask":"##/##/####"},on:{"input":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }